import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useAuthorization } from '../hooks/useAuthorization';
import { ROLES } from '../hooks/useAuthorization';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireEditor?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireEditor = false }) => {
  const { user, loading } = useAuth();
  const { hasRole } = useAuthorization();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireEditor && !hasRole([ROLES.ADMIN, ROLES.APP_EDITOR])) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 